let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ekBDv")).then(() => parcelRequire('8jisX'));